import { h } from 'preact';
import * as BaseComp from 'components/bolt/movieDetails/movieDetails.js';
import { joinClasses } from 'utils/utils';
import DeviceDetector from 'device-detector-js';
import { findInVNode } from 'utils/vnode';

import s from 'components/bolt/movieDetails/movieDetails.sss';

export default class MovieDetails extends BaseComp.default {

	isFirefox() {
		if (typeof window !== 'undefined') {
			const deviceDetector = new DeviceDetector();
			const userAgent = window.navigator.userAgent;
			const device = deviceDetector.parse(userAgent);
			return device.client.name === 'Firefox';
		}
		return false;
	}

	render({ type, tt, bg, buttons, cookieHeight = 0, cookieBannerOpen, dualViewEnabled, isWidget }, { bgVideo, backgroundStyle, quotesCarouselPosition }) {
		let baseRender = super.render({ type, tt, bg, buttons, cookieHeight, cookieBannerOpen, dualViewEnabled, isWidget }, { bgVideo, backgroundStyle, quotesCarouselPosition });

		const isFirefox = this.isFirefox();

		let details = findInVNode(baseRender, '.' + s.details);
		details.attributes.class = joinClasses(details.attributes.class, isFirefox && s.isFirefox);
		return baseRender;
	}
}
